import { Avatar } from '@octopus-do/octopus-storybook'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import type React from 'react'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import { MemberButton } from '../MemberButton'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  member: TeammateDto
  disabled: boolean
}

const getLabel = ({ role, activity }: TeammateDto) => {
  if (role === 'ADMIN') {
    return 'Admin'
  }

  if (activity === 'active') {
    return role.toLowerCase()
  }

  return activity
}

export const MemberItem = forwardRef<HTMLButtonElement, Props>(
  ({ member, disabled }, ref) => {
    const { avatar, color, name, activity, email } = member

    const label = getLabel(member)

    return (
      <li className={css.list_item}>
        <div className={css.item}>
          <div className={clsJoin(css.left, css[activity])}>
            <Avatar color={color} media={avatar} name={name} size="md" />

            <div className={css.info}>
              <div className={css.name}>{name}</div>
              <div className={css.email}>{email}</div>
            </div>
          </div>

          <div className={css.role_slot}>
            <MemberButton ref={ref} disabled={disabled} label={label} />
          </div>
        </div>

        <div className={css.divider} />
      </li>
    )
  }
)
